<template>
   <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
</template>
<script>
    export default {
         data() {
    return {
        self: this,
        tableColumns :[
        {
          title: "权限名称",
          key: "name",
          align: "center",
        },
        {
          title: "权限类型",
          key: "type",
          align: "center",
            render: (h, params) => {
            var issupper = params.row.type == 0 ? "页面级权限" : "按钮级权限";
            return h("span", issupper);
          }
        },
        {
          title: "权限描述",
          align: "center",
          key: "description"
        },
        {
          title: "页面ID",
          align: "center",
          key: "menu_id"
        },
        {
          title: "按钮ID",
          align: "center",
          key: "button_id",
        },
        {
          title: "角色ID",
          align: "center",
          key: "role_id"
        },]
        }
        },
        props: {
            tableData: Array
        }
    };
</script>


// WEBPACK FOOTER //
// src/pages/role/roletable.vue